import { axiosClient } from '@definitions'
import { ResourceSociodemographicApiType } from '@api/types'
import { catchApiError } from '@utils'

export const getSociodemographicResource = async (): Promise<ResourceSociodemographicApiType[]> => {
  try {
    const axios = axiosClient()
    const resp = await axios.get<ResourceSociodemographicApiType[]>(
      `/ResourceService/Resource/Sociodemographic`,
    )
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}
